import { CustomError } from "ts-custom-error";

export class NotLoggedInError extends CustomError {
  constructor() {
    super("Unable to make API request: user is not logged in.");
  }
}
